import React from 'react';
import { useReveal } from '../lib/useReveal';
const SKILLS = ['Tortas premium', 'Cupcakes aesthetic', 'Box dulces modernas', 'Packaging elegante', 'Instagram profesional', 'Reels atractivos', 'Precios correctos', 'Decoración moderna', 'Emprender desde casa'];
export function MockupShowcaseSection() {
  const [ref, isVisible] = useReveal();
  return <section className="py-12 md:py-16 px-6 bg-[#fff8f9]" data-id="element-155">
      <div className="max-w-4xl mx-auto text-center" data-id="element-156">
        <span className="inline-block text-[#e89aaa] text-xs font-bold tracking-[0.25em] uppercase mb-3" data-id="element-157">
          ♡ Tu transformación ♡
        </span>
        <h2 className="text-2xl md:text-4xl font-serif font-bold text-[#6b4f3a] mb-8 leading-tight" data-id="element-158">
          Todo lo que vas <br data-id="element-159" />
          <span className="italic text-[#e89aaa]" data-id="element-160">a poder hacer.</span>
        </h2>

        <div ref={ref} className={`reveal grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4 ${isVisible ? 'is-visible' : ''}`} data-id="element-161">
          {SKILLS.map((skill, i) => <div key={i} className="flex items-center gap-2.5 bg-white rounded-2xl p-4 border border-[#f4b6c2]/30 shadow-sm hover:shadow-md transition-shadow text-left" data-id="element-162">
              <span className="w-6 h-6 rounded-full bg-[#fdf2f4] flex items-center justify-center text-[#e89aaa] text-xs shrink-0" data-id="element-163">
                ✓
              </span>
              <span className="text-sm md:text-base font-medium text-[#6b4f3a]" data-id="element-164">
                {skill}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}